import mapKnownValues from "@/utils/mapKnownValues";

export enum NotificationValueTypeEnum {
  amps = "AMPS",
  kw = "KW"
}

export enum ConfigurationThresholdTypeEnum {
  absolute = "ABSOLUTE",
  percent = "PERCENT"
}

export enum NotificationMethodEnum {
  email = "EMAIL",
  push = "PUSH",
  slack = "SLACK",
  text = "TEXT"
}

export type NotificationConfigAPIResponse = {
  id: string;
  propertyId: string;
  valueType: NotificationValueTypeEnum;
  thresholdValue: number;
  thresholdType: ConfigurationThresholdTypeEnum;
  notifyMethods: NotificationMethodEnum[];
  notifyUsers: string[];
  note: string;
  createdAt: string; // date
};

export default class NotificationConfig {
  id = "";
  propertyId = "";
  valueType = NotificationValueTypeEnum.kw;
  thresholdValue = 0;
  thresholdType = ConfigurationThresholdTypeEnum.percent;
  notifyMethods: NotificationMethodEnum[] = [];
  notifyUsers: string[] = [];
  note = "";
  createdAt = new Date();

  constructor(params: Partial<NotificationConfig> = {}) {
    mapKnownValues(this, params);
  }

  toJson() {
    return {
      ...this,
      id: this.id === "" ? undefined : this.id,
      createdAt: this.id === "" ? undefined : this.createdAt
    };
  }

  get readableThresholdType() {
    return this.thresholdType === ConfigurationThresholdTypeEnum.percent ? "% of soft limit" : "";
  }

  get readableValueType() {
    return this.valueType === NotificationValueTypeEnum.kw ? "kW" : "Amps";
  }

  get rule() {
    return `>= ${this.thresholdValue}${this.readableThresholdType} ${this.readableValueType}`;
  }

  static fromAPIResponse(response: NotificationConfigAPIResponse) {
    return new NotificationConfig({
      ...response,
      createdAt: new Date(response.createdAt)
    });
  }
}
